import { BasicEnumerable } from "../BasicEnumerable.js";
export const prepend = (source, element) => {
    function* iterator() {
        yield element;
        yield* source;
    }
    return new BasicEnumerable(iterator);
};
